import { assignCommonProperties } from '../../util/data/assign-common-properties.js'

import { jsonProperty, jsonClass } from '@sumbricht/json-class-serializer'

@jsonClass('BlockStyle')
export class BlockStyle {
	@jsonProperty(String)
	name!: string
	@jsonProperty(String)
	prefix?: string
	@jsonProperty(String)
	value?: string
	@jsonProperty(Boolean)
	isExpression: boolean = false

	constructor(init?: Partial<BlockStyle>) {
		assignCommonProperties(this, init)
	}
}
